/**
 * 用户反馈API
 */

import request from './request';

/**
 * 根据task_id获取用户反馈列表
 * @param {string} taskId - 任务ID
 * @returns {Promise<Object>} 反馈列表
 */
export function getUserFeedbackByTaskId(taskId) {
  return request.get(`/user-feedback/task/${taskId}`);
}

/**
 * 根据task_id获取用户反馈统计
 * @param {string} taskId - 任务ID
 * @returns {Promise<Object>} 反馈统计
 */
export function getUserFeedbackStatsByTaskId(taskId) {
  return request.get(`/user-feedback/task/${taskId}/stats`);
}
